import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Button, Drawer } from '@tecsinapse/cortex-react'
import React from 'react'
import { IoMdClose } from 'react-icons/io'
import { FormNewFolderFragment } from './form-new-folder-fragment'
import { useNovaPastaDialog } from '../hooks/use-nova-pasta-dialog'
import { FormProvider } from 'react-hook-form'
import { OptionSelect } from '../../../core/utils/types'
import { ItemBiblioteca } from '../../../core/types/graphql'

export interface NovaPastaDrawerProps {
  open: boolean
  pastaOptions: OptionSelect[]
  pastaAtual: ItemBiblioteca
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const NovaPastaDrawer = ({
  open,
  pastaOptions,
  pastaAtual,
  setOpen
}: NovaPastaDrawerProps) => {
  const { closeForm, form, onSubmit } = useNovaPastaDialog({
    pastaAtual,
    setOpen
  })

  const { handleSubmit } = form

  return (
    <Drawer open={open} onClose={closeForm}>
      <FormProvider {...form}>
        <div className='flex w-[30rem] flex-col h-full'>
          <div className={'flex flex-row justify-between items-center mb-deca'}>
            <p className='font-bold mb-deca text-h3 w-full text-center'>
              <Trans>Nova Pasta</Trans>
            </p>
            <Button variants={{ size: 'square' }} onClick={closeForm}>
              <IoMdClose />
            </Button>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormNewFolderFragment
              showLocation
              pastaAtual={pastaAtual}
              showName
              closeForm={closeForm}
              pastaOptions={pastaOptions}
              submitLabel={t`Criar Pasta`}
            />
          </form>
        </div>
      </FormProvider>
    </Drawer>
  )
}
